<!--Privacy:Hi, 隐私协议 2020/06/04 17:24:58 YuAng-->

<template>
   <ts-page-layout class="its-privacy" center>
       <div v-html="content" class="its-privacy-content"></div>
   </ts-page-layout>
</template>
<script>
import {downloadCenterApi} from '../../../utils/api'
export default {
  name: 'Privacy',
  data () {
       return {
        content: '<h3>协议正在制定中，请稍等~~</h3>'
       }
  },
  created () {
     let type = this.$route.params.id + 'Content'
     if (type) {
        this[type]()
     }
  },
  mounted () {
     this.$root.switchNavigation('隐私协议')
  },
  methods: {
     privacyContent: function () {
        let vm = this
        downloadCenterApi.getAppDownload('TEACHER_ANDROID').then(function (resp) {
            let content = resp.body[0].privacyPolicy
            if (content) {
               vm.content = content
            }
        }) 
     }
  }
}
</script>

<style scoped>
.its-privacy-content {
   width: 100%;
   min-height: 600px; 
   background: white; 
   padding: 20px; 
   margin: 10px 0
}
</style>